import React from 'react'
import PlacementCustomCard from 'src/components/customCard/PlacementCustomCard';
import RecuiterCustomCard from 'src/components/customCard/RecuiterCustomCard';
import { HiringFlowType, UserExperienceLevelType } from 'types';
import { HiringFlowScreen } from 'src/pages/newRecruiterFlow/DrivePrototype';
import { useSearchParams } from 'react-router-dom';


interface Props {
	setHiringFlowScreen: (screen: HiringFlowScreen) => void;
}
const HireRemote = ({ setHiringFlowScreen }: Props) => {
  const [searchParams, setSearchParams] = useSearchParams();


  let hireData: {
		title: string;
		description: string;
		imageSrc: string;
		path?: string;
		
	} = {
    title: 'Hire Remotely',
    description: 'Freshers or experienced candidates for immediate hiring',
    imageSrc: '/assets/recruiterImages/hireRemote.svg',
  }

  let cardData: {
        key: HiringFlowType;
        status: string;
        imageSrc: string;
        description: string;
        path:string
        disabled?: boolean;
      // disabled?: boolean;
      // onBack?: () => void;
          
	}[] =[ 
    {
      key: 'fresher',
      status: 'Hire Freshers',
      imageSrc: '/assets/recruiterImages/fresher.svg',
      description: '(Up to 1 years of experience)',
      path: `/fresher-candidates?userExperience=${JSON.stringify([UserExperienceLevelType.FRESHER])}`,

    },
    {
      key: 'lateral',
      status: 'Hire Experienced Candidates',
      imageSrc: '/assets/recruiterImages/experience.svg',
      description: '(2+ years of experience)',
      path: `/fresher-candidates?userExperience=${JSON.stringify([UserExperienceLevelType.OneToTwoYears])}`,

    }
]
  return (
    <div className='flex flex-col md:flex-row gap-[15px] md:gap-[78px] items-center mt-[50px] md:max-w-[1440px] mx-auto'>
      <div className=''>
      <PlacementCustomCard 
          title={hireData.title}
          description={hireData.description}
          imageSrc={hireData.imageSrc} 
          />  
      </div>
      {/* drives */}
      <div className='flex flex-row gap-[10px] overflow-x-auto w-[91%] mx-auto md:mx-0 md:!max-w-[60%]'>
        
        {cardData.map((card, index) => (
         <RecuiterCustomCard 
            key={index}
            status={card.status}
            imageSrc={card.imageSrc}
            description={card.description}
            disabled={card.disabled ?? false}
            onClick={() => {
                if (card.key === 'fresher') {
                setHiringFlowScreen(HiringFlowScreen.SELECT_FRESHER_HIRING_FLOW);
                } else if (card.key === 'lateral') {
                setHiringFlowScreen(HiringFlowScreen.SELECT_LATERAL_HIRING_FLOW);
                }
              const newSearchParams = new URLSearchParams(searchParams);
              // console.log('hiringFlowType:', hiringFlowType);
              newSearchParams.set('hiringFlowType', card.key);
              setSearchParams(newSearchParams);
            }}         
            />
        ))}
      </div>
      {/* swapper */}
      {/* <div></div> */}
    </div>
  )
}

export default HireRemote








